var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInfoOutline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.4706 22 22 17.4706 22 12C22 6.53922 17.4608 2 11.9902 2C6.52941 2 2 6.53922 2 12C2 17.4706 6.53922 22 12 22ZM12 20.3333C7.37255 20.3333 3.67647 16.6275 3.67647 12C3.67647 7.38235 7.36275 3.66667 11.9902 3.66667C16.6176 3.66667 20.3235 7.38235 20.3333 12C20.3431 16.6275 16.6275 20.3333 12 20.3333ZM11.9118 8.5098C12.6275 8.5098 13.1863 7.94118 13.1863 7.23529C13.1863 6.51961 12.6275 5.95098 11.9118 5.95098C11.2059 5.95098 10.6373 6.51961 10.6373 7.23529C10.6373 7.94118 11.2059 8.5098 11.9118 8.5098ZM10.2843 17.3922H14.2745C14.6765 17.3922 14.9902 17.1078 14.9902 16.7059C14.9902 16.3235 14.6765 16.0196 14.2745 16.0196H13.0588V11.0294C13.0588 10.5 12.7941 10.1471 12.2941 10.1471H10.451C10.049 10.1471 9.73529 10.451 9.73529 10.8333C9.73529 11.2353 10.049 11.5196 10.451 11.5196H11.5V16.0196H10.2843C9.88235 16.0196 9.56863 16.3235 9.56863 16.7059C9.56863 17.1078 9.88235 17.3922 10.2843 17.3922Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInfoOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-info-outline.3c85b55831db3cfb62e3e36c3574e1a8.svg";